import * as modalCodes from 'modules/messageSystem/constants/modalCodes';
import { addModal } from 'modules/messageSystem/actions/addModal';
import { resetAppointmentConfig } from './createAppointment';

export const invokeCreateAppointmentDiscardModal = cb => dispatch => {
  dispatch(
    addModal({
      typeId: modalCodes.CREATE_APPOINTMENT_DISCARD_MODAL,
      onOk: () => {
        cb();
        dispatch(resetAppointmentConfig());
      },
      canAddDuplicate: false,
      isForce: true,
      preventClosingWhenDismiss: true,
    }),
  );
};

export const invokeUpdateAppointmentDiscardModal = cb => dispatch => {
  dispatch(
    addModal({
      typeId: modalCodes.UPDATE_APPOINTMENT_DISCARD_MODAL,
      onOk: () => {
        cb();
        dispatch(resetAppointmentConfig());
      },
      canAddDuplicate: false,
      isForce: true,
      preventClosingWhenDismiss: true,
    }),
  );
};

export const invokeAppointmentErrorModal = (errorMessage, onOk) => dispatch =>
  dispatch(
    addModal({
      typeId: modalCodes.CANNOT_CREATE_OR_UPDATE_APPOINTMENT_MODAL,
      canAddDuplicate: false,
      isForce: true,
      preventClosingWhenDismiss: true,
      bodyValues: {
        message: errorMessage,
        title: errorMessage.title,
      },
      onOk,
    }),
  );

export const invokeFetchedByAnotherProviderModal = () => dispatch => dispatch(
  addModal({
    typeId: modalCodes.FETCHED_BY_ANOTHER_PROVIDER_MODAL,
    canAddDuplicate: false,
    isForce: true,
  }),
);

export const invokeUpdateGroupedAppointmentConfirmationModal = (resolve) => dispatch =>
  dispatch(
    addModal({
      typeId: modalCodes.CONFIRM_UPDATE_GROUPED_APPOINTMENT_MODAL,
      canAddDuplicate: false,
      preventClosingWhenDismiss: true,
      isForce: true,
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    }),
  );
